<div fxLayout="row" fxLayoutGap="8px" class="filter-status" *ngIf="quantity > 0">
  <div class="title filter-text">{{quantity}} filtro(s) aplicado(s): </div>
  <div *ngIf="startDate !== '' && endDate !== ''" class="filter-text">Data: {{startDate | date: "shortDate"}} - {{endDate | date: "shortDate"}}</div>
  <div *ngIf="status.length > 0" class="filter-text">|</div>
  <div *ngIf="status.length > 0" class="filter-text">Situação: {{status}}</div>
  <div *ngIf="account.length > 0" class="filter-text">|</div>
  <div *ngIf="account.length > 0" class="filter-text">Conta: {{account}}</div>
</div>
